import { useSite } from '../context/SiteContext';
import { curriculum } from '../data/course';
import { buildSchedule, toBn } from '../lib/utils';
import { ClockIcon, VideoIcon } from './Icons';

export default function Schedule() {
  const { course } = useSite();
  // One entry per curriculum item, so every class has a title even if totalClasses drifts.
  const classes = buildSchedule({ ...course, totalClasses: curriculum.length });
  const classByDay = new Map(classes.map((c) => [c.day, c]));

  return (
    <section id="schedule" className="bg-slate-900 py-20 text-white">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow bg-white/10 text-cta-400">সময়সূচি</span>
          <h2 className="section-title text-white">একদিন ক্লাস, একদিন প্র্যাকটিস — {toBn(course.windowDays)} দিনেই শেষ</h2>
          <p className="mt-4 text-lg text-slate-300">
            প্রতিটি ক্লাসের পরের দিন বিরতি, যাতে শেখা বিষয়টি নিজে প্র্যাকটিস করে পাকা করতে পারেন। চাকরি বা পড়াশোনার পাশাপাশি সহজেই চালিয়ে যেতে পারবেন।
          </p>
        </div>

        {/* 15-day strip */}
        <div className="mt-12 overflow-x-auto pb-2">
          <ol className="mx-auto grid min-w-[640px] max-w-5xl gap-1.5" style={{ gridTemplateColumns: `repeat(${course.windowDays}, minmax(0, 1fr))` }}>
            {Array.from({ length: course.windowDays }, (_, i) => {
              const day = i + 1;
              const cls = classByDay.get(day);
              return (
                <li
                  key={day}
                  className={`flex flex-col items-center rounded-lg py-3 text-center ${cls ? 'bg-excel-500' : 'bg-white/5 text-slate-400'}`}
                  title={cls ? `ক্লাস ${toBn(cls.index + 1)}` : 'প্র্যাকটিস'}
                >
                  <span className="text-[11px] opacity-80">দিন</span>
                  <span className="text-lg font-bold">{toBn(day)}</span>
                  <span className="mt-0.5 text-[10px]">{cls ? `ক্লাস ${toBn(cls.index + 1)}` : day === course.windowDays ? '🎓' : 'প্র্যাকটিস'}</span>
                </li>
              );
            })}
          </ol>
          <div className="mx-auto mt-3 flex min-w-[640px] max-w-5xl flex-wrap justify-center gap-5 text-sm text-slate-400">
            <span className="flex items-center gap-2"><span className="h-3 w-3 rounded bg-excel-500" /> লাইভ Excel ক্লাস</span>
            <span className="flex items-center gap-2"><span className="h-3 w-3 rounded bg-white/10" /> প্র্যাকটিস দিন</span>
          </div>
        </div>

        {/* Class list */}
        <div className="mx-auto mt-12 grid max-w-5xl grid-cols-1 gap-3 md:grid-cols-2">
          {classes.map((c) => {
            const item = curriculum[c.index];
            return (
              <div key={c.index} className="flex items-center gap-4 rounded-xl bg-white/5 p-4 ring-1 ring-white/10">
                <div className="flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-xl bg-excel-500">
                  <span className="text-[10px] leading-none opacity-80">ক্লাস</span>
                  <span className="text-xl font-bold leading-tight">{toBn(c.index + 1)}</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm text-slate-400">
                    দিন {toBn(c.day)}
                  </div>
                  <div className="truncate font-semibold">{item.title}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mx-auto mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-x-8 gap-y-3 text-slate-300">
          {course.classTime && (
            <span className="flex items-center gap-2"><ClockIcon className="h-5 w-5 text-cta-400" /> প্রতি ক্লাস {course.classTime}</span>
          )}
          {course.platform && (
            <span className="flex items-center gap-2"><VideoIcon className="h-5 w-5 text-cta-400" /> লাইভ ক্লাস {course.platform}-এ</span>
          )}
          <span className="flex items-center gap-2">🎓 {toBn(course.windowDays)} দিনে কোর্স সম্পন্ন</span>
        </div>
      </div>
    </section>
  );
}
